import { Fragment } from 'react';
import { FiltersProvider } from '../../../components/providers/FiltersProvider';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import NetworkSettlementsList from './NetworkSettlementsList';

const breadCrumb = [
    { name: 'Administración' },
    { name: 'Redes comerciales y departamentos', href: menuRoutes.networks.path },
    { name: 'Liquidaciones de Red', href: menuRoutes.networks.path + menuRoutes.networks.settlements },
];

const NetworkSettlementsListWrapper = () => {
    const now = new Date();

    return (
        <Fragment>
            <FiltersProvider
                defaultFilterFilters={{
                    month: now.getMonth() + 1,
                    year: now.getFullYear(),
                }}
            >
                <PageHeader title="Liquidaciones de Red" breadcrumb={breadCrumb} />
                <NetworkSettlementsList />
            </FiltersProvider>
        </Fragment>
    );
};

export default NetworkSettlementsListWrapper;
